export default __webpack_public_path__ + "static/media/img-video-1.e689edd9.png";